import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isLocked", "children"];
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import ButtonContentWrapper from './ButtonContentWrapper';
import { useIsUngatedForBreeze } from '../../../hooks/useIsUngatedForBreeze';
import { BREEZE_SPECIAL } from '../../../constants/BreezeUse';
import { getStyledAILoadingButton } from './styledButtons/StyledAIBaseLoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
export function AIBaseLoadingButton(_ref) {
  let {
      isLocked = false,
      children
    } = _ref,
    uiButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isUngatedForBreeze = useIsUngatedForBreeze();
  const useOverride = uiButtonProps.use === BREEZE_SPECIAL ? undefined : uiButtonProps.use;
  if (!isUngatedForBreeze) {
    return /*#__PURE__*/_jsx(UILoadingButton, Object.assign({}, uiButtonProps, {
      use: useOverride,
      children: /*#__PURE__*/_jsx(ButtonContentWrapper, {
        isLocked: isLocked,
        children: children
      })
    }));
  }
  const AILoadingButtonComponent = getStyledAILoadingButton(uiButtonProps.use);
  return /*#__PURE__*/_jsx(AILoadingButtonComponent, Object.assign({}, uiButtonProps, {
    use: useOverride,
    children: children
  }));
}